export const envMODE = process.env.type ? process.env.type : "PROD";
